<template>
  <div class="reveil-player">
    <div class="reveil-player__wrapper">
      <div :id="`jplayer_wrapper_${playerId}`">
        <div :id='`jquery_jplayer_${playerId}`' class='jp-jplayer'></div>
        <div :id='`jp_container_${playerId}`' class='jp-audio'>
          <div class='jp-type-single'>
            <div class='jp-gui jp-interface'>
              <ul class='jp-controls'>
                <li>
                  <p class='caption'><a href='javascript:;' class='jp-play no_underline' tabindex='1'>
                      <div class='play'></div>
                      <object :data='iconPlayScalable' class='play-obj' type='image/svg+xml'></object>
                    </a>
                  </p>
                </li>
                <li>
                  <p class='caption'><a href='javascript:;' class='jp-pause no_underline' tabindex='1'>
                      <div class='pause'></div>
                      <object :data='iconPauseScalable' class='pause-obj' type='image/svg+xml'></object>
                    </a>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const iconPlayScalable = require('@/assets/simpleplayer/images/play_scalable.svg')
const iconPauseScalable = require('@/assets/simpleplayer/images/pause_scalable.svg')

export default {
  name: 'Player',
  props: ['audioUrl', 'playerId', "startTime", "endTime"],
  data: () => ({
    iconPlayScalable: iconPlayScalable,
    iconPauseScalable: iconPauseScalable,
  }),
  mounted() {
    this.newPlayer();
  },
  updated() {
    this.newPlayer();    
  },
  methods: {
    newPlayer() {
      $(`#jquery_jplayer_${this.playerId}`).jPlayer({
        ready() {
          this.playerId = this.playerId * 1;
          $(this).jPlayer('setMedia', {
            mp3: "https://partneraudio.wavefarm.org/reveil.mp3",
            // mp3: "http://locus.creacast.com:9001/london_stave_hill.mp3",
          });
        },
        // play: function() {
        // $(".jp-jplayer").not(this).jPlayer("stop");
        // },
        swfPath: 'scripts',
        supplied: 'mp3',
        cssSelectorAncestor: `#jp_container_${this.playerId}`,
        wmode: 'window',
        smoothPlayBar: true,
        keyEnabled: true,
      });
    },
  },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.reveil-player {
  position: relative;
  top: -0.5rem;
  height:0;
}
.play, .pause,.play-obj,.pause-obj {
  height: 2rem;
  width: 2rem;
}

.play-obj{
  top:0px;
  left: 0px;
}
.pause-obj{
  top: 0;
  left: 0px;
}

.jp-play, .jp-pause{
  position: relative;
  display: inline-block;
}
.play, .pause {
  visibility: hidden;
  margin-top: 0px !important;
  padding-top: 0px;
}
.play-obj,
.pause-obj {
  pointer-events: none;
  position: absolute;
}

.jp-player {
  display: inline-block; 
  line-height: 0px;
}

.jp-controls {
  margin: 0;
  padding: 0;
  display: inline-block;
}
.jp-controls .caption {
  margin: 0;
}
.jp-controls li {
  display: inline;
  line-height: 0px;
}

.jp-play {
  display: block;
}

.jp-gui {
  display: inline-block;
  line-height: 0px;
}
.jp-type-single {
  display: inline-block;
  line-height: 0px;
}
.jp-audio {
  display: inline-block;
  line-height: 0px;
}

.jp-jplayer div { line-height: 0px; }

a:active {
    background-color: transparent;
    outline: 0px;
}

a:focus {
  background-color: transparent;
  outline: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Player.vue